import React from 'react'
import { Container, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { noResultsMap } from './reusableContent'
import { useSelector } from 'react-redux'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '60px',
  },
})

export const ComingSoon = () => {
  const classes = useStyles()
  const { language } = useSelector(state => state.auth)

  return (
    <Container className={classes.root}>
      <Typography variant="h4">{noResultsMap.comingSoon[language]}</Typography>
    </Container>
  )
}
